<template>
    <div>
        Privacy
    </div>
</template>

<script setup>

</script>

<style lang="scss"
       scoped></style>
